
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'PropertySettingsUI',
  currentProjectVersion: 'static-1.40973',
  depVersions: {
  "PropertySettingsUI": "static-1.40973",
  "ai-components-ui-library": "static-1.3575",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "client-types": "static-1.335",
  "conditional-properties-service-client": "static-1.2047",
  "crm-pipelines-api-client-types": "static-1.1884",
  "customer-data-objects": "static-1.5069",
  "data-fetching-client": "static-1.6831",
  "demographics-client": "static-1.2899",
  "feedback-loader": "static-1.24445",
  "head-dlb": "static-1.2572",
  "history": "static-4.15",
  "hs-test-utils": "static-1.5566",
  "hub-http": "static-1.2732",
  "hubspot-apollo-client": "static-1.2278",
  "hubspot-dlb": "static-2.514",
  "HubStyleTokens": "static-2.9118",
  "I18n": "static-7.1304",
  "inbound-db-properties-service-client": "static-1.2025",
  "jasmine-immutable": "static-1.429",
  "jasmine-runner": "static-1.3938",
  "lodash": "static-1.3",
  "PortalIdParser": "static-2.254",
  "property-management-lib": "static-1.9194",
  "property-usages-lib": "static-1.2332",
  "quartz": "static-1.4130",
  "quartz-core": "static-1.3349",
  "raven": "static-3.3290",
  "react": "static-7.133",
  "react-dlb": "static-1.43",
  "react-redux": "static-7.16",
  "react-router-dom": "static-5.26",
  "redux": "static-4.16",
  "redux-thunk": "static-2.17",
  "ReduxMessenger": "static-2.8122",
  "reference-resolvers": "static-1.5775",
  "reference-resolvers-lite": "static-1.5414",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.5604",
  "settings-ui-lib": "static-1.9941",
  "transmute": "static-2.29",
  "ui-addon-upgrades": "static-9.14368",
  "ui-business-units-lib": "static-1.6206",
  "ui-components-test-utils": "static-1.3259",
  "UIComponents": "static-3.6068",
  "webpack-env": "static-1.41",
  "access-control-lib": "static-1.7954",
  "apps-service-types": "static-1.2207",
  "atom": "static-1.2927",
  "bark-lib": "static-1.12623",
  "classnames": "static-2.10",
  "codemirror": "static-5.62",
  "conditional-property-settings-modal": "static-1.6643",
  "copilot-toolkit": "static-1.2784",
  "crm-properties-common-lib": "static-1.3191",
  "cssUtils": "static-1.321",
  "customer-data-filters-ui": "static-1.30083",
  "customer-data-objects-ui-components": "static-1.10270",
  "customer-data-properties": "static-1.41677",
  "customer-data-property-utils": "static-1.5263",
  "customer-data-reference-ui-components": "static-1.10371",
  "customer-data-ui-utilities": "static-1.7297",
  "enviro": "static-4.275",
  "events-ui-components-lib": "static-1.5467",
  "ExportDialog": "static-6.7806",
  "FormUrlGenerator": "static-2.2282",
  "foundations-assets": "static-1.2347",
  "foundations-components": "static-1.4298",
  "foundations-theming": "static-1.1499",
  "frontend-preferences-client": "static-1.5393",
  "hoist-non-react-statics": "static-3.9",
  "hs-lodash": "static-4.9",
  "hs-promise-utils": "static-1.2991",
  "hubspot-url-utils": "static-1.1962",
  "HubStyle": "static-2.9428",
  "icons": "static-2.585",
  "immer": "static-1.33",
  "immutable": "static-2.19",
  "laboratory-lib": "static-3.4669",
  "metrics-js": "static-1.7033",
  "onboarding-tours": "static-1.11990",
  "outpost": "static-1.1916",
  "PatternValidationJS": "static-1.437",
  "property-description-translator": "static-1.1446",
  "property-translator": "static-1.2971",
  "quick-fetch": "static-1.1826",
  "react-codemirror": "static-1.8052",
  "react-dom": "static-7.85",
  "react-flip-move": "static-1.40",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-rhumb": "static-1.14081",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.3240",
  "react-virtualized": "static-2.67",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.2202",
  "SafeStorage": "static-1.2085",
  "sanitize": "static-1.6",
  "sanitize-text": "static-1.5718",
  "sassPrefix": "static-1.122",
  "self-service-api": "static-1.7632",
  "settings-ui-nav": "static-2.7357",
  "SharedI18nStrings": "static-1.160",
  "styled-components": "static-2.40",
  "StyleGuideUI": "static-3.433",
  "timezone-utils": "static-2.2941",
  "ui-addon-avatars": "static-2.7066",
  "ui-addon-draggable": "static-3.2347",
  "ui-addon-i18n": "static-1.8320",
  "ui-addon-iframeable": "static-1.6576",
  "ui-addon-opt": "static-4.6249",
  "ui-addon-teams": "static-1.18041",
  "ui-asset-management-lib": "static-1.7451",
  "ui-images": "static-2.766",
  "ui-shepherd-react": "static-3.7471",
  "ui-shepherd-tracker": "static-1.4852",
  "usage-tracker": "static-1.5111",
  "usage-tracker-container": "static-1.5101",
  "usage-tracker-core": "static-1.4961",
  "user-context": "static-1.2613",
  "wootric-nps": "static-1.4514",
  "hs-promise-rejection-tracking": "static-1.2969",
  "raven-hubspot": "static-1.3597",
  "bend-plugin-trellis-migration": "static-1.1152",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.407",
  "quartz-webpack": "static-1.354",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.6754",
  "chatspot-core": "static-1.11861",
  "ContentUtils": "static-1.59693",
  "hs-story-utils": "static-1.6572",
  "msw": "static-1.39",
  "ui-fonts": "static-1.327",
  "graphql": "static-1.51",
  "ts-schema": "static-1.1984",
  "signup-constants": "static-1.14114",
  "HeadJS": "static-2.518",
  "framer-motion": "static-1.30",
  "hs-test-utils-bend-plugin": "static-1.677",
  "testing-library": "static-1.113",
  "apollo-link-hub-http": "static-2.2289",
  "i18n-data": "static-1.188",
  "moment-timezone": "static-5.17",
  "jasmine": "static-4.1857",
  "customer-data-filters": "static-1.43896",
  "data-quality-reports-lib": "static-1.362",
  "data-quality-types-lib": "static-1.366",
  "file-manager-components": "static-1.14927",
  "FileManagerCore": "static-1.30427",
  "formula-editor": "static-1.9850",
  "inbound-db-meta-service-client": "static-1.1673",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-window": "static-1.13",
  "react-window-infinite-loader": "static-1.5",
  "reporting-action-components": "static-1.32561",
  "quartz-core-utils": "static-1.997",
  "dispatcher": "static-1.105",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.586",
  "hub-http-shared-msw-handlers": "static-1.5458",
  "hubspotter-http": "static-1.2587",
  "hubspotter-http-shared-msw-handlers": "static-1.5456",
  "mobile-manifest-mixins": "static-1.289",
  "platform-navigation-bootstrap": "static-1.9391",
  "csstype": "static-1.8",
  "external-options-client-types": "static-1.1992",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.4142",
  "flux-actions": "static-1.251",
  "react-colorpicker": "static-2.7693",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "feature-store-service-types": "static-1.2452",
  "growth-monetization-service-types": "static-1.2459",
  "salesImages": "static-1.490",
  "upgrade-management-service-types": "static-1.2443",
  "browser-prettier": "static-1.11",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.5321",
  "customer-data-filters-ui-msw-helpers": "static-1.12514",
  "framework-builder-read-service-client": "static-1.1970",
  "framework-data-schema-quick-fetch": "static-1.4046",
  "commerce-products-lib": "static-1.1912",
  "crm-message-bus": "static-1.31914",
  "google-libphonenumber": "static-1.4",
  "inbounddb-objects-service-types": "static-1.1945",
  "object-builder-ui-client": "static-1.36827",
  "pipeline-validation-client-types": "static-1.1947",
  "ui-addon-form-validation": "static-1.8511",
  "react-dnd-compat": "static-1.2005",
  "react-immutable-render-mixin": "static-1.9",
  "behavioral-events-service-types": "static-1.13289",
  "bend-plugin-foundations-components": "static-1.566",
  "floating-ui": "static-1.20",
  "react-aria": "static-1.32",
  "tanstack-table": "static-1.10",
  "foundations-theming-base": "static-1.484",
  "superstore": "static-1.2288",
  "getting-started-shared-tasks": "static-1.7760",
  "growth-data-modal": "static-1.2506",
  "growth-onboarding-confetti": "static-1.626",
  "ui-universal-auth": "static-1.6171",
  "browser-eslint": "static-2.9",
  "navigation-components": "static-1.11914",
  "getting-started-shared-tasks-store": "static-1.6878",
  "cms-field-types": "static-1.2296",
  "content-icons-ui": "static-1.1816",
  "deep-diff": "static-1.5",
  "reporting-enablement": "static-1.12902",
  "reporting-visualizations": "static-1.50108",
  "media-bridge-lib": "static-1.14784",
  "video-data-lib": "static-1.25875",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.28078",
  "urlinator": "static-1.2171",
  "content-assistance-lib": "static-1.4676",
  "dashboard-lib": "static-1.71762",
  "integrations-lib": "static-1.8185",
  "reporting-data": "static-1.58027",
  "reporting-snowflake": "static-1.46654",
  "share-with-third-party-component-lib": "static-1.6009",
  "platform-infra-nav-components": "static-1.5690",
  "persist-promise": "static-1.1344",
  "idb-keyval": "static-1.14",
  "magpie-lib": "static-1.3021",
  "magpie-types": "static-1.2480",
  "simple-logging-lib": "static-1.634",
  "data-quality-ui-library": "static-1.4204",
  "html-to-image": "static-1.23",
  "report-customization-components": "static-1.5498",
  "reporting-plugins": "static-1.4724",
  "reporting-reports": "static-1.57717",
  "reporting-ui-components": "static-2.55313",
  "highcharts": "static-8.71",
  "react-transition-group": "static-1.7",
  "ui-addon-video-player": "static-1.6365",
  "ui-coaching-tips": "static-1.18052",
  "onboarding-scopes": "static-1.3919",
  "redux-actions": "static-3.7",
  "integrations-error-boundary-lib": "static-1.5598",
  "native-integrations-shared-strings": "static-1.5292",
  "reporting-client-types": "static-1.1174",
  "reporting-datasets-permissions-lib": "static-1.3422",
  "ui-addon-react-router-dom": "static-1.7095",
  "growth-onboarding-feedback-components": "static-1.3921",
  "growth-onboarding-reliability": "static-1.2586"
},
  depPathPrefixes: {
  "PropertySettingsUI": "/PropertySettingsUI/static-1.40973",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.3575",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "client-types": "/client-types/static-1.335",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2047",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.1884",
  "customer-data-objects": "/customer-data-objects/static-1.5069",
  "data-fetching-client": "/data-fetching-client/static-1.6831",
  "demographics-client": "/demographics-client/static-1.2899",
  "feedback-loader": "/feedback-loader/static-1.24445",
  "head-dlb": "/head-dlb/static-1.2572",
  "history": "/history/static-4.15",
  "hs-test-utils": "/hs-test-utils/static-1.5566",
  "hub-http": "/hub-http/static-1.2732",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.2278",
  "hubspot-dlb": "/hubspot-dlb/static-2.514",
  "HubStyleTokens": "/HubStyleTokens/static-2.9118",
  "I18n": "/I18n/static-7.1304",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2025",
  "jasmine-immutable": "/jasmine-immutable/static-1.429",
  "jasmine-runner": "/jasmine-runner/static-1.3938",
  "lodash": "/lodash/static-1.3",
  "PortalIdParser": "/PortalIdParser/static-2.254",
  "property-management-lib": "/property-management-lib/static-1.9194",
  "property-usages-lib": "/property-usages-lib/static-1.2332",
  "quartz": "/quartz/static-1.4130",
  "quartz-core": "/quartz-core/static-1.3349",
  "raven": "/raven/static-3.3290",
  "react": "/react/static-7.133",
  "react-dlb": "/react-dlb/static-1.43",
  "react-redux": "/react-redux/static-7.16",
  "react-router-dom": "/react-router-dom/static-5.26",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.17",
  "ReduxMessenger": "/ReduxMessenger/static-2.8122",
  "reference-resolvers": "/reference-resolvers/static-1.5775",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.5414",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.5604",
  "settings-ui-lib": "/settings-ui-lib/static-1.9941",
  "transmute": "/transmute/static-2.29",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.14368",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.6206",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.3259",
  "UIComponents": "/UIComponents/static-3.6068",
  "webpack-env": "/webpack-env/static-1.41",
  "access-control-lib": "/access-control-lib/static-1.7954",
  "apps-service-types": "/apps-service-types/static-1.2207",
  "atom": "/atom/static-1.2927",
  "bark-lib": "/bark-lib/static-1.12623",
  "classnames": "/classnames/static-2.10",
  "codemirror": "/codemirror/static-5.62",
  "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.6643",
  "copilot-toolkit": "/copilot-toolkit/static-1.2784",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.3191",
  "cssUtils": "/cssUtils/static-1.321",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.30083",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.10270",
  "customer-data-properties": "/customer-data-properties/static-1.41677",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.5263",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.10371",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7297",
  "enviro": "/enviro/static-4.275",
  "events-ui-components-lib": "/events-ui-components-lib/static-1.5467",
  "ExportDialog": "/ExportDialog/static-6.7806",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.2282",
  "foundations-assets": "/foundations-assets/static-1.2347",
  "foundations-components": "/foundations-components/static-1.4298",
  "foundations-theming": "/foundations-theming/static-1.1499",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.5393",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hs-lodash": "/hs-lodash/static-4.9",
  "hs-promise-utils": "/hs-promise-utils/static-1.2991",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.1962",
  "HubStyle": "/HubStyle/static-2.9428",
  "icons": "/icons/static-2.585",
  "immer": "/immer/static-1.33",
  "immutable": "/immutable/static-2.19",
  "laboratory-lib": "/laboratory-lib/static-3.4669",
  "metrics-js": "/metrics-js/static-1.7033",
  "onboarding-tours": "/onboarding-tours/static-1.11990",
  "outpost": "/outpost/static-1.1916",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "property-description-translator": "/property-description-translator/static-1.1446",
  "property-translator": "/property-translator/static-1.2971",
  "quick-fetch": "/quick-fetch/static-1.1826",
  "react-codemirror": "/react-codemirror/static-1.8052",
  "react-dom": "/react-dom/static-7.85",
  "react-flip-move": "/react-flip-move/static-1.40",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-rhumb": "/react-rhumb/static-1.14081",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.3240",
  "react-virtualized": "/react-virtualized/static-2.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.2202",
  "SafeStorage": "/SafeStorage/static-1.2085",
  "sanitize": "/sanitize/static-1.6",
  "sanitize-text": "/sanitize-text/static-1.5718",
  "sassPrefix": "/sassPrefix/static-1.122",
  "self-service-api": "/self-service-api/static-1.7632",
  "settings-ui-nav": "/settings-ui-nav/static-2.7357",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
  "styled-components": "/styled-components/static-2.40",
  "StyleGuideUI": "/StyleGuideUI/static-3.433",
  "timezone-utils": "/timezone-utils/static-2.2941",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.7066",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.2347",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.8320",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.6576",
  "ui-addon-opt": "/ui-addon-opt/static-4.6249",
  "ui-addon-teams": "/ui-addon-teams/static-1.18041",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.7451",
  "ui-images": "/ui-images/static-2.766",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.7471",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.4852",
  "usage-tracker": "/usage-tracker/static-1.5111",
  "usage-tracker-container": "/usage-tracker-container/static-1.5101",
  "usage-tracker-core": "/usage-tracker-core/static-1.4961",
  "user-context": "/user-context/static-1.2613",
  "wootric-nps": "/wootric-nps/static-1.4514",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.2969",
  "raven-hubspot": "/raven-hubspot/static-1.3597",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1152",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.407",
  "quartz-webpack": "/quartz-webpack/static-1.354",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.6754",
  "chatspot-core": "/chatspot-core/static-1.11861",
  "ContentUtils": "/ContentUtils/static-1.59693",
  "hs-story-utils": "/hs-story-utils/static-1.6572",
  "msw": "/msw/static-1.39",
  "ui-fonts": "/ui-fonts/static-1.327",
  "graphql": "/graphql/static-1.51",
  "ts-schema": "/ts-schema/static-1.1984",
  "signup-constants": "/signup-constants/static-1.14114",
  "HeadJS": "/HeadJS/static-2.518",
  "framer-motion": "/framer-motion/static-1.30",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.677",
  "testing-library": "/testing-library/static-1.113",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2289",
  "i18n-data": "/i18n-data/static-1.188",
  "moment-timezone": "/moment-timezone/static-5.17",
  "jasmine": "/jasmine/static-4.1857",
  "customer-data-filters": "/customer-data-filters/static-1.43896",
  "data-quality-reports-lib": "/data-quality-reports-lib/static-1.362",
  "data-quality-types-lib": "/data-quality-types-lib/static-1.366",
  "file-manager-components": "/file-manager-components/static-1.14927",
  "FileManagerCore": "/FileManagerCore/static-1.30427",
  "formula-editor": "/formula-editor/static-1.9850",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.1673",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-window": "/react-window/static-1.13",
  "react-window-infinite-loader": "/react-window-infinite-loader/static-1.5",
  "reporting-action-components": "/reporting-action-components/static-1.32561",
  "quartz-core-utils": "/quartz-core-utils/static-1.997",
  "dispatcher": "/dispatcher/static-1.105",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.586",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.5458",
  "hubspotter-http": "/hubspotter-http/static-1.2587",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.5456",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.289",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.9391",
  "csstype": "/csstype/static-1.8",
  "external-options-client-types": "/external-options-client-types/static-1.1992",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.4142",
  "flux-actions": "/flux-actions/static-1.251",
  "react-colorpicker": "/react-colorpicker/static-2.7693",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "feature-store-service-types": "/feature-store-service-types/static-1.2452",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2459",
  "salesImages": "/salesImages/static-1.490",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2443",
  "browser-prettier": "/browser-prettier/static-1.11",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.5321",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.12514",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.1970",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.4046",
  "commerce-products-lib": "/commerce-products-lib/static-1.1912",
  "crm-message-bus": "/crm-message-bus/static-1.31914",
  "google-libphonenumber": "/google-libphonenumber/static-1.4",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.1945",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.36827",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.1947",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.8511",
  "react-dnd-compat": "/react-dnd-compat/static-1.2005",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "behavioral-events-service-types": "/behavioral-events-service-types/static-1.13289",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.566",
  "floating-ui": "/floating-ui/static-1.20",
  "react-aria": "/react-aria/static-1.32",
  "tanstack-table": "/tanstack-table/static-1.10",
  "foundations-theming-base": "/foundations-theming-base/static-1.484",
  "superstore": "/superstore/static-1.2288",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.7760",
  "growth-data-modal": "/growth-data-modal/static-1.2506",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.626",
  "ui-universal-auth": "/ui-universal-auth/static-1.6171",
  "browser-eslint": "/browser-eslint/static-2.9",
  "navigation-components": "/navigation-components/static-1.11914",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.6878",
  "cms-field-types": "/cms-field-types/static-1.2296",
  "content-icons-ui": "/content-icons-ui/static-1.1816",
  "deep-diff": "/deep-diff/static-1.5",
  "reporting-enablement": "/reporting-enablement/static-1.12902",
  "reporting-visualizations": "/reporting-visualizations/static-1.50108",
  "media-bridge-lib": "/media-bridge-lib/static-1.14784",
  "video-data-lib": "/video-data-lib/static-1.25875",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.28078",
  "urlinator": "/urlinator/static-1.2171",
  "content-assistance-lib": "/content-assistance-lib/static-1.4676",
  "dashboard-lib": "/dashboard-lib/static-1.71762",
  "integrations-lib": "/integrations-lib/static-1.8185",
  "reporting-data": "/reporting-data/static-1.58027",
  "reporting-snowflake": "/reporting-snowflake/static-1.46654",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.6009",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.5690",
  "persist-promise": "/persist-promise/static-1.1344",
  "idb-keyval": "/idb-keyval/static-1.14",
  "magpie-lib": "/magpie-lib/static-1.3021",
  "magpie-types": "/magpie-types/static-1.2480",
  "simple-logging-lib": "/simple-logging-lib/static-1.634",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.4204",
  "html-to-image": "/html-to-image/static-1.23",
  "report-customization-components": "/report-customization-components/static-1.5498",
  "reporting-plugins": "/reporting-plugins/static-1.4724",
  "reporting-reports": "/reporting-reports/static-1.57717",
  "reporting-ui-components": "/reporting-ui-components/static-2.55313",
  "highcharts": "/highcharts/static-8.71",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.6365",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.18052",
  "onboarding-scopes": "/onboarding-scopes/static-1.3919",
  "redux-actions": "/redux-actions/static-3.7",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.5598",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.5292",
  "reporting-client-types": "/reporting-client-types/static-1.1174",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.3422",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7095",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.3921",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.2586"
}
};
